import { Location } from 'history';
import isNumber from 'lodash-es/isNumber';
import {
    CONFIRM,
    FORUM_ADD_QUESTION_IN_COUNSELLING,
    SEO_DESCRIPTION_FORUM_POST_perex,
    SEO_TITLE_FORUM_POST_title,
    SEO_TITLE_FORUM_POST_title_AT_PAGE_pagenum,
    TURN_NOTIFICATIONS_OFF,
    TURN_NOTIFICATIONS_ON,
} from 'mk/autogenerated/translations/PostDetailPage.c215428516effb168251449d946a9d32'
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import { addPostUnauthenticated, analyticsStoreEvent, toastAdd } from 'mk2/actions';
import { CommentEntity } from 'mk2/apps/blogs/schemas';
import { forumDeletePost, postSendHeart, postToggleNotifications } from 'mk2/apps/forum/actions';
import { COMMENT_CREATE_FORM_NAME, CommentFormData } from 'mk2/apps/forum/components/CommentCreateEditForm';
import { CONTESTS_TOPIC_ID } from 'mk2/apps/forum/constants';
import PostDetail from 'mk2/apps/forum/containers/PostDetail/PostDetail';
import {
    postDetailAddCommentUnauthenticated,
    postDetailCommentCreateTrigger,
    postDetailCommentDeleteTrigger,
    postDetailCommentReply,
    postDetailFetchTrigger,
    postDetailMoveUpComment,
    postDetailToggleCommentHighlight,
    postDetailTrackTrigger,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.actions';
import { POST_DETAIL_MENU_MORE } from 'mk2/apps/forum/containers/PostDetail/PostDetail.constants';
import {
    PostDetailPageState,
    PostDetailVirtualPageState,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.reducers';
import {
    getComplaintShowCached,
    getDenormalizedComments,
    getDenormalizedCommentsWithComplaint,
    getDenormalizedMicroPosts,
    getForumPostDetailPageState,
    getForumPostDetailState,
    getForumPostDetailVirtualPageState,
    getPostDetailPost,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.selectors';
import { PostDetailRight } from 'mk2/apps/forum/containers/PostDetail/PostDetailRight';
import { FORUM_COMMENT_MENU_MORE } from 'mk2/apps/forum/helpers';
import { getForumNotificationsOn } from 'mk2/apps/forum/reducers';
import {
    CampaignEntity,
    ContestEntity,
    ContestSchema,
    CounsellingEntity,
    MessageSchema,
    MicroPostEntity,
    MicroPostSchema,
    PageRef,
    PostEntity,
} from 'mk2/apps/forum/schemas';
import { breadcrumbsForum, discussionForumPosting, postOG } from 'mk2/apps/forum/structuredData';
import * as urls from 'mk2/apps/forum/urls';
import { isCounsellingPost, parsePageNumber } from 'mk2/apps/forum/utils';
import Btn, { BtnType } from 'mk2/components/Btn';
import ServerErrorToast from 'mk2/components/toasts/ServerErrorToast';
import { FormPageType } from 'mk2/constants';
import { abFetch } from 'mk2/containers/AB/AB.actions';
import { ABState } from 'mk2/containers/AB/AB.reducers';
import { getABVariant } from 'mk2/containers/AB/AB.selectors';
import { complaintInitToggle } from 'mk2/containers/Complaint/Complaint.actions';
import { menuToggle } from 'mk2/containers/Menu/Menu.actions';
import { cacheLast } from 'mk2/helpers/cache';
import { mkReduxFormMapDispatchToProps, mkReduxFormMapStateToProps } from 'mk2/helpers/form';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import FormPage, { FormPageDispatchProps, FormPageStateProps } from 'mk2/pages/FormPage';
import { BrandingProps, HalfpageProps } from 'mk2/pages/Page';
import {
    AppState,
    getComplaintShow,
    getRequestBaseUrl,
    getRequestDeviceIsIOS,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
    getResponseRenderedAt,
} from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity } from 'mk2/schemas';
import { getDenormalizedEntity } from 'mk2/selectors';
import { interpolate } from 'mk2/services/i18n';
import { Store } from 'mk2/store/configureStore';
import * as React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {
}

interface StateProps extends FormPageStateProps {
    post: PostEntity;
    comments: CommentEntity[];
    commentsWithComplaint: CommentEntity[];
    pageRef: PageRef; // page number or symbolic name (e.g. 'last') of current page. Null if page=... value is invalid
    numberOfPages: number;
    mobile: boolean;
    isIOS: boolean;
    permissions: string[];
    initialValues: CommentFormData;
    requestUser: UserEntity;
    loadingState: LoadingState;
    errorMessage: string;
    renderedAt: number;
    postComplaint: boolean;
    complaintsOpened: boolean[];
    baseUrl: string;
    notificationsOn: number[];
    commentToBeHighlighted: number | 'last';
    nextPosts: MicroPostEntity[];
    similarPosts: MicroPostEntity[];
    recentPosts: MicroPostEntity[];

    contest: ContestEntity | null;   // ak sme v poste z topicu Sutaze, obsahuje data o aktualnej sutazi
    contestAlreadyParticipated: boolean;
    counselling: CounsellingEntity;
    campaign: CampaignEntity;

    variant: ABState;
}

interface DispatchProps extends FormPageDispatchProps {
    onLoad(topicSlug: string, postSlug: string, page: PageRef, currentUrl: Location, numCommentsBeforeLoad: number);
    onReply(username: string, textArea: HTMLTextAreaElement);
    onReport(entity: string, id: number);
    onToggleMenuMore(id: number);
    onStoreEvent(name: string, props: any);
    onAddComment(postId: number, values: CommentFormData);
    onAddCommentUnauthenticated();
    onAddPostUnauthenticated();
    onDeleteComment(id: number);
    onMoveUpComment(id: number);

    onToggleMenuMorePostDetail();
    onToggleNotifications(username: string, channelId: number, follow: boolean);
    onDelete(id: number);

    onFailureToast();
    onTrackEdit(itemId: number);
    onSendHeart();
    onToggleCommentHighlight(key: string, commentId: number | 'last');

    onLoadAB();
}

type RouteProps = RouteComponentProps<{
    topicSlug: string;
    postSlug: string;
}>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

const initialValues = {
    text: '',
    photos: [],
    sticker: null,
};

export default class PostDetailPage extends FormPage<OwnProps & RouteProps, StateProps, DispatchProps> {

    private onToggleNotificationsCache = cacheLast();

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const { match: { params: { topicSlug, postSlug } } } = ownProps;

            const pageRef = parsePageNumber(ownProps.location);
            const postDetailState = getForumPostDetailState(state, topicSlug, postSlug);
            const postDetailPageState: PostDetailPageState | PostDetailVirtualPageState = isNumber(pageRef)
                ? getForumPostDetailPageState(state, topicSlug, postSlug, pageRef)
                : getForumPostDetailVirtualPageState(state, topicSlug, postSlug, pageRef);
            const post = getPostDetailPost(state, postSlug, topicSlug);
            const comments = isNumber(pageRef)
                ? getDenormalizedComments(state, MessageSchema, (postDetailPageState as PostDetailPageState).commentIds)
                : [];
            const nextPosts = getDenormalizedMicroPosts(state, MicroPostSchema, postDetailState.nextPostIds);
            const similarPosts = getDenormalizedMicroPosts(state, MicroPostSchema, postDetailState.similarPostIds);
            const recentPosts = getDenormalizedMicroPosts(state, MicroPostSchema, postDetailState.recentPostIds);

            const commentsWithComplaint = getDenormalizedCommentsWithComplaint(state, MessageSchema, postDetailState.commentsWithComplaintIds);
            const complaintsOpened = getComplaintShowCached(state, comments);

            return {
                ...mkReduxFormMapStateToProps(COMMENT_CREATE_FORM_NAME)(state),
                post,
                comments,
                commentsWithComplaint,
                pageRef,
                numberOfPages: postDetailState.numberOfPages,
                loadingState: postDetailPageState.loadingState,
                errorMessage: postDetailPageState.errorMessage,
                mobile: getRequestDeviceMobile(state),
                isIOS: getRequestDeviceIsIOS(state),
                permissions: getRequestPermissions(state),
                initialValues,
                requestUser: getRequestUser(state),
                renderedAt: getResponseRenderedAt(state),
                postComplaint: post && getComplaintShow(state, 'forum-thread', post.id),
                complaintsOpened,
                baseUrl: getRequestBaseUrl(state),
                notificationsOn: getForumNotificationsOn(state),
                commentToBeHighlighted: postDetailState.commentToBeHighlighted,
                nextPosts,
                similarPosts,
                recentPosts,

                contest: getDenormalizedEntity<ContestEntity>(state, ContestSchema, postDetailState.contestId),
                contestAlreadyParticipated: postDetailState.contestAlreadyParticipated,
                counselling: postDetailState.counselling,
                campaign: postDetailState.campaign,
                variant: getABVariant(state, 'forum_compact'),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            ...mkReduxFormMapDispatchToProps(COMMENT_CREATE_FORM_NAME),
            onLoad: postDetailFetchTrigger,
            onReply: postDetailCommentReply,
            onStoreEvent: analyticsStoreEvent,
            onReport: (entity: string, id: number) => complaintInitToggle(entity, id, true),
            onToggleMenuMore: (id: number) => menuToggle(FORUM_COMMENT_MENU_MORE(id)),
            onFailureToast: () => toastAdd('error', { component: ServerErrorToast }),
            onAddComment: postDetailCommentCreateTrigger,
            onAddCommentUnauthenticated: postDetailAddCommentUnauthenticated,
            onAddPostUnauthenticated: addPostUnauthenticated,
            onDeleteComment: postDetailCommentDeleteTrigger,
            onMoveUpComment: postDetailMoveUpComment,
            onToggleMenuMorePostDetail: () => menuToggle(POST_DETAIL_MENU_MORE),
            onToggleNotifications: (username: string, channelId: number, follow: boolean) =>
                postToggleNotifications(username, 'thread', channelId, follow),
            onDelete: forumDeletePost,
            onTrackEdit: postDetailTrackTrigger,
            onSendHeart: postSendHeart,
            onToggleCommentHighlight: postDetailToggleCommentHighlight,
            onLoadAB: () => abFetch('forum_compact'),
        };
    }

    public getMetaTitle(props: Props): string {
        const { post, pageRef } = props;

        let title = null;
        if (post && isNumber(pageRef)) {
            title = pageRef > 1
                ? interpolate(SEO_TITLE_FORUM_POST_title_AT_PAGE_pagenum, { title: post.heading, pagenum: pageRef })
                : interpolate(SEO_TITLE_FORUM_POST_title, {title: post.heading});
        }

        return title;
    }

    public getMetaDescription(props: Props): string {
        const { post } = props;
        return post
            ? interpolate(SEO_DESCRIPTION_FORUM_POST_perex, {perex: post.perex})
            : null;
    }

    public getOpenGraphData(props: Props, baseUrl: string, currentUrl: string): {[key: string]: string} {
        const { post } = props;

        if (post) {
            return {
                ...super.getOpenGraphData(props, baseUrl, currentUrl),
                ...postOG(baseUrl, post),
            };
        }
    }

    public getStructuredData(props: Props): object[] {
        const { post, baseUrl } = props;
        if (post) {
            const topic = post.topic ? post.topic : null;
            return [
                breadcrumbsForum(baseUrl, undefined, topic, post),
                discussionForumPosting(baseUrl, post),
            ];
        }
    }

    public getMetaRobots(props: Props): string {
        const { post } = props;
        return post && post.noindex ? 'noindex,nofollow' : 'index,follow';
    }

    public render(props: Props): false | JSX.Element {
        return (
            <PostDetail {...props} />
        );
    }

    public renderRight(props: Props): JSX.Element {
        return (
            <PostDetailRight {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        const { match: { params: { topicSlug } } } = props;
        return url(urls.forumTopic, { topicSlug });
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        const { post } = props;
        if (post && (post.deletedAt || post.isNoAds || post.topic.isCommercial)) {
            return null;
        }

        return {
            zone: 'Forum Thread - Halfpage Sticky (Desktop)',
        };
    }

    public getBrandingProps(props: Props): BrandingProps {
        const { post } = props;

        if (!post) {
            return {
                zone: 'Forum - Branding',
            };
        }

        if (post && (post.deletedAt || post.isNoAds)) {
            return null;
        }

        if (post.topic.isSMM) {
            return {
                zone: 'Forum - Branding Dni s',
                targeting: { mk_dni_s: post.topic.slug.substr(0, 40) },
            };
        } else if (post.topic.id === CONTESTS_TOPIC_ID) {
            return {
                zone: 'Forum - Branding Sutaz',
                targeting: { mk_sutaz: post.slug.substr(0, 40) },
            };
        } else if (post.topic.isCommercial) {
            return null;
        } else {
            return {
                zone: 'Forum - Branding',
            };
        }
    }

    public getHeaderRight(props: Props): React.ReactNode {
        const { currentFormPage, onCloseFormPage } = props;
        return currentFormPage === FormPageType.Main
            ? this.getHeaderRightOnMainFormPage(props)
            : (
                <Btn
                    label={CONFIRM}
                    onClick={onCloseFormPage}
                />
            );
    }

    public getHeaderRightOnMainFormPage(props: Props): React.ReactNode {
        const {
            post, onToggleNotifications, onAddPostUnauthenticated,
            notificationsOn, requestUser,
        } = props;
        const isCounselling = isCounsellingPost(post);

        if (!post || post.deletedAt || post.topic.deletedAt || !isAuthenticated(requestUser)) {
            return null;
        }

        const follow: boolean = notificationsOn.indexOf(post.id) > -1;

        return (isCounselling ? (
            <Btn
                key="btn"
                type={BtnType.Blue}
                label={FORUM_ADD_QUESTION_IN_COUNSELLING}
                link={isAuthenticated(requestUser) ? url(urls.forumCounsellingNew, { topicSlug: post.topic.slug }) : null}
                onClick={isAuthenticated(requestUser) ? null : onAddPostUnauthenticated}
            />
        ) : (
            <Btn
                type={BtnType.BlueOutline}
                onClick={this.onToggleNotificationsCache(() => {
                    onToggleNotifications(requestUser.username, post.id, !follow);
                }, requestUser.username, post.id, follow)}
                icon={`${ follow ?
                    'fa-bell-slash-o' :
                    'fa-bell-o'
                }`}
                label={interpolate(follow ?
                    TURN_NOTIFICATIONS_OFF :
                    TURN_NOTIFICATIONS_ON,
                )}
            />
            )
        );
    }

    public getSubmitButton(props: Props): React.ReactNode {
        /* not used submit button */
        return null;
    }

    public hasMobileLogo(props: Props): boolean {
        return true;
    }

    public registerInStore(store?: Store<AppState>) {
        return this.loadAndRegisterReducerAndSaga(
            'containers.forum.forumPostDetail',
            import('mk2/apps/forum/containers/PostDetail/PostDetail.reducers' /* webpackChunkName: "forum.PostDetail" */),
            import('mk2/apps/forum/containers/PostDetail/PostDetail.sagas' /* webpackChunkName: "forum.PostDetail" */),
            store,
        );
    }

}
